module.exports = __webpack_public_path__ + "media/images/logorgreen-4f2e636e.png";